import { Button, Img, Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import plus from "../../Assets/plus_icon.png";

export const PostJobButton = () => {
  const navigate = useNavigate();
  return (
    <>
      <Button
        position={"fixed"}
        bottom={10}
        right={6}
        bg={"#6C56FB"}
        color={"#fff"}
        fontSize={16}
        fontStyle={400}
        fontFamily={"Roboto"}
        borderRadius={47}
        alignItems={"center"}
        gap={2}
        px={"26px"}
        py={"15px"}
        zIndex={+100}
        onClick={() => navigate("/hiring/recruiter/createPost")}
      >
        <Img style={{ height: "12px", width: "12px" }} src={plus} alt="icon" />
        <Text mt={"2px"}>Create Post</Text>
      </Button>
    </>
  );
};
